// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type SocialAuthConfFieldsFragment = { userManagement: { id: string, auth0Conf: { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined } | undefined, cognitoConf: { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined } | undefined } | undefined };

export type SocialAuthConfQueryVariables = Exact<{
  site: string;
}>;


export type SocialAuthConfQuery = { userManagement: { id: string, auth0Conf: { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined } | undefined, cognitoConf: { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined } | undefined } | undefined };

export type Auth0ConfigFragment = { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined };

export type CognitoConfigFragment = { id: string, clientId: string | undefined, domain: string | undefined, connections: Array<{ handle: string | undefined, title: string | undefined } | undefined> | undefined };

export const Auth0ConfigFragmentDoc = gql`
    fragment Auth0ConfigFragment on UserManagementAuth0Conf {
  id
  clientId
  domain
  connections {
    handle
    title
  }
}
    `;
export const CognitoConfigFragmentDoc = gql`
    fragment CognitoConfigFragment on UserManagementCognitoConf {
  id
  clientId
  domain
  connections {
    handle
    title
  }
}
    `;
export const SocialAuthConfFieldsFragmentDoc = gql`
    fragment SocialAuthConfFields on Query {
  userManagement {
    id
    auth0Conf(site: $site) {
      ...Auth0ConfigFragment
    }
    cognitoConf(site: $site) {
      ...CognitoConfigFragment
    }
  }
}
    ${Auth0ConfigFragmentDoc}
${CognitoConfigFragmentDoc}`;
export const SocialAuthConfQueryDocument = gql`
    query SocialAuthConfQuery($site: String!) {
  ...SocialAuthConfFields
}
    ${SocialAuthConfFieldsFragmentDoc}`;